export const normalizePromo = (s: string) => s.trim().toUpperCase();

export function capturePromoFromUrl() {
	const params = new URLSearchParams(window.location.search);
	const promo = params.get("promo");

	if (promo && promo.trim().length > 0) {
		return promo;
	}

	return "";
}

export type PromoCodeSearch = {
	promo: string | undefined;
};

export function validatePromoCodeSearch(
	search: PromoCodeSearch,
): { promo: string | undefined } | undefined {
	if (!search.promo) {
		return undefined;
	}

	return {
		promo: search.promo,
	};
}
